import { render, staticRenderFns } from "./AdditionForm.vue?vue&type=template&id=4e3424b4&scoped=true&"
import script from "./AdditionForm.vue?vue&type=script&lang=js&"
export * from "./AdditionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3424b4",
  null
  
)

export default component.exports